import * as Yup from "yup";
export const reportMessageValidationSchema = Yup.object({
  memberEmail: Yup.string()
    .email("Invalid email format")
    .required("Member name is required"),
  reportMessageText: Yup.string().required(
    "Report Message cannot be left empty"
  ),
});
